import React from "react";
// import { Link } from "react-router-dom";
import { GmapsComponent, numberToINR } from "./";
import { Animated } from "react-animated-css";
import { MdLocationOn } from "react-icons/md";

const PIFBody = ({
  propertyInformationData,
  markerCoordinates,
  propertySubType,
}) => {
  const [activeTab, setActiveTab] = React.useState("specification");
  const buildingList = [
    "apartment",
    "independent house",
    "farm house",
    "business and hotel",
    "serviced apartment to commercial showroom",
  ];
  return (
    <>
      <Animated animationIn='fadeIn' animationOut='fadeOut' isVisible={true}>
        <div className='col-span-12 sm:col-span-12 mt-2 -z-30'>
          <div className='col-span-12 rounded-md '>
            {markerCoordinates.lat ? (
              <GmapsComponent
                zoom={14}
                position={markerCoordinates}
                draggableMarker={false}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          className={`ml-2 ${
            propertyInformationData.latitude !== "" &&
            propertyInformationData.longitude !== ""
              ? "absolute -mt-32"
              : "mt-4 w-3/12"
          } flex-col px-4 py-3 rounded-sm shadow-yellow-2 bg-gray-50 bg-opacity-100 z-30 shadow-lg`}>
          <span className='mt-0 block w-full py-0 pb-0 font-semibold text-2xl text-yellow-dark text-justify '>
            {propertyInformationData.landmark}
          </span>
          <div
            className={`${
              propertyInformationData.latitude !== "" &&
              propertyInformationData.longitude !== ""
                ? "flex flex-wrap p-0 gap-0.5 mt-1 cursor-pointer"
                : "hidden"
            } `}
            onClick={(e) => {
              window.open(
                "https://www.google.com/maps/dir//" +
                  markerCoordinates.lat +
                  "," +
                  markerCoordinates.lng,
                "_blank",
                "noopener,noreferrer",
              );
            }}>
            <MdLocationOn className='text-xl text-yellow-2 pt-0.75' />
            <span className='text-sm text-gray-dark'>
              {propertyInformationData.addressline1}
            </span>
            {propertyInformationData.addressline2.toString().trim() !== "" && (
              <span className='text-sm text-gray-dark'>
                {", " + propertyInformationData.addressline2}
              </span>
            )}
            {propertyInformationData.city.toString().trim() !== "" && (
              <span className='text-sm text-gray-dark'>
                {", " + propertyInformationData.city}
              </span>
            )}
            {propertyInformationData.state.toString().trim() !== "" && (
              <span className='text-sm text-gray-dark'>
                {", " + propertyInformationData.state}
              </span>
            )}
            {propertyInformationData.country.toString().trim() !== "" && (
              <span className='text-sm text-gray-dark'>
                {", " + propertyInformationData.country}
              </span>
            )}
            {propertyInformationData.pin_code !== 0 && (
              <span className='text-sm text-gray-dark'>
                {" - " + propertyInformationData.pin_code}
              </span>
            )}
          </div>
          {!Number.isNaN(propertyInformationData.price) && (
            <span className='mt-2 block w-full py-0 pb-0 font-semibold text-lg text-gray-700 text-justify '>
              {numberToINR(propertyInformationData.price)}
            </span>
          )}
          <div className='py-2'>
            <label htmlFor='pin_code' className={`block text-xs font-medium `}>
              Tagged Locations
            </label>
            <div className='mt-1 w-full py-0 pl-5 flex gap-2'>
              {propertyInformationData?.pifLocations &&
              propertyInformationData?.pifLocations.length > 0 ? (
                propertyInformationData.pifLocations.map((item) => (
                  <span className='px-2 py-1 text-white text-sm font-normal bg-yellow-dark rounded-sm'>
                    {item.name}
                  </span>
                ))
              ) : (
                <span className='px-2 py-1 text-sm font-semibold bg-yellow-2 rounded-sm'>
                  No Locations Tagged
                </span>
              )}
            </div>
          </div>
        </div>
      </Animated>
      <div className='mt-20'>
        <Animated animationIn='fadeIn' animationOut='fadeOut' isVisible={true}>
          <ul className='hidden text-sm font-medium text-center text-gray-500 divide-x divide-yellow-dark rounded-md shadow sm:flex '>
            <li
              className='w-full'
              onClick={(event) => {
                setActiveTab("specification");
              }}>
              <span
                className={`inline-block cursor-pointer w-full p-4 text-black ${
                  activeTab == "specification"
                    ? "bg-yellow-2 hover:bg-yellow-dark"
                    : "bg-gray-100  hover:bg-gray-400"
                } rounded-tl-md active focus:outline-none duration-300`}>
                Specification
              </span>
            </li>
            <li
              className='w-full'
              onClick={(event) => {
                setActiveTab("docsandmisc");
              }}>
              <span
                className={`inline-block cursor-pointer w-full p-4 ${
                  activeTab == "docsandmisc"
                    ? "bg-yellow-2 hover:bg-yellow-dark"
                    : "bg-gray-100  hover:bg-gray-400"
                } focus:outline-none  duration-300`}>
                Docs & Miscellaneous
              </span>
            </li>
            <li
              className='w-full'
              onClick={(event) => {
                setActiveTab("buildandland");
              }}>
              <span
                className={`inline-block cursor-pointer w-full p-4 ${
                  activeTab == "buildandland"
                    ? "bg-yellow-2 hover:bg-yellow-dark"
                    : "bg-gray-100  hover:bg-gray-400"
                } focus:outline-none  duration-300`}>
                Building / Land Details
              </span>
            </li>
            <li
              className='w-full'
              onClick={(event) => {
                setActiveTab("hindrance");
              }}>
              <span
                className={`inline-block cursor-pointer w-full p-4 ${
                  activeTab == "hindrance"
                    ? "bg-yellow-2 hover:bg-yellow-dark"
                    : "bg-gray-100  hover:bg-gray-400"
                } focus:ring-4 focus:outline-none focus:ring-blue-300 duration-300 `}>
                Hindrance & Comments
              </span>
            </li>
            <li
              className='w-full'
              onClick={(event) => {
                setActiveTab("amenities");
              }}>
              <span
                className={`inline-block cursor-pointer w-full p-4 rounded-tr-md ${
                  activeTab == "amenities"
                    ? "bg-yellow-2 hover:bg-yellow-dark"
                    : "bg-gray-100  hover:bg-gray-400"
                } focus:ring-4 focus:outline-none focus:ring-blue-300 duration-300 `}>
                Amenities
              </span>
            </li>
          </ul>
        </Animated>
      </div>
      <div className='-mt-0.5 mb-2' id='contents'>
        {activeTab === "specification" && (
          <Animated
            animationIn='bounceInLeft'
            animationOut='bounceOutLeft'
            isVisible={activeTab === "specification"}>
            <div className='p-4 rounded-sm'>
              <div className='flex justify-items-start'>
                <div className='w-full'>
                  <div className='grid grid-cols-12 p-2 gap-2'>
                    <div className='col-span-12 sm:col-span-1'>
                      <label
                        htmlFor='locationType'
                        className='block text-xs font-medium text-gray-700'>
                        Location Type
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.locationType
                          ? propertyInformationData?.locationType
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='shape'
                        className='block text-xs font-medium text-gray-700'>
                        Shape
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.shape
                          ? propertyInformationData?.shape
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='approachRoadSize'
                        className='block text-xs font-medium text-gray-700'>
                        Approach Road Size
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.approachRoadSize
                          ? propertyInformationData?.approachRoadSize + " cms"
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-1'>
                      <label
                        htmlFor='roadType'
                        className='block text-xs font-medium text-gray-700'>
                        Road Type
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.roadType
                          ? propertyInformationData?.roadType
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='frontage'
                        className='block text-xs font-medium text-gray-700'>
                        Frontage
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.frontage
                          ? propertyInformationData?.frontage
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='surroundingDetails'
                        className='block text-xs font-medium text-gray-700'>
                        Surrounding Details
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.surroundingDetails
                          ? propertyInformationData?.surroundingDetails
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-1'>
                      <label
                        htmlFor='roadKuthal'
                        className='block text-xs font-medium text-gray-700'>
                        Road Kuthal
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.roadKuthal ? (
                          <span className='font-semibold'>Yes</span>
                        ) : (
                          "No"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animated>
        )}
        {activeTab === "docsandmisc" && (
          <Animated
            animationIn='bounceInRight'
            animationOut='bounceOutLeft'
            isVisible={activeTab === "docsandmisc"}>
            <div className='p-4 rounded-sm'>
              <div className='flex justify-items-start'>
                <div className='w-full'>
                  <div className='grid grid-cols-12 p-2 gap-2'>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='propertyNumber'
                        className='block text-xs font-medium text-gray-700'>
                        Property Number
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.propertyNumber
                          ? propertyInformationData?.propertyNumber
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='propertyNumberType'
                        className='block text-xs font-medium text-gray-700'>
                        Property Number Type
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.propertyNumberType
                          ? propertyInformationData?.propertyNumberType
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='guideLineValue'
                        className='block text-xs font-medium text-gray-700'>
                        Guide - Line Value
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.guideLineValue
                          ? propertyInformationData?.guideLineValue
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-3'>
                      <label
                        htmlFor='approvalAuthority'
                        className='block text-xs font-medium text-gray-700'>
                        Approval Authority
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.approvalAuthority
                          ? propertyInformationData?.approvalAuthority
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='approvalType'
                        className='block text-xs font-medium text-gray-700'>
                        Approval Type
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.approvalType
                          ? propertyInformationData?.approvalType
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='villageName'
                        className='block text-xs font-medium text-gray-700'>
                        Village Name
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.villageName
                          ? propertyInformationData?.villageName
                          : "--"}
                      </span>
                    </div>

                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='sroName'
                        className='block text-xs font-medium text-gray-700'>
                        SRO Name
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.sroName
                          ? propertyInformationData?.sroName
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor='approvalNumber'
                        className='block text-xs font-medium text-gray-700'>
                        Approval Number
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.approvalNumber
                          ? propertyInformationData?.approvalNumber
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='talukName'
                        className='block text-xs font-medium text-gray-700'>
                        Taluk Name
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.talukName
                          ? propertyInformationData?.talukName
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='accusationPossibility'
                        className='block text-xs font-medium text-gray-700'>
                        Accusation Possibility
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.accusationPossibility
                          ? propertyInformationData?.accusationPossibility
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3'>
                      <label
                        htmlFor='accusationPossibilityOther'
                        className='block text-xs font-medium text-gray-700'>
                        Accusation Possibility Other
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.accusationPossibilityOther
                          ? propertyInformationData?.accusationPossibilityOther
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-1 pt-2'>
                      {propertyInformationData?.loanableEnabled && (
                        <span className='bg-orange-100 text-orange-800 text-xs font-semibold mt-2 px-2.5 py-1.5 rounded dark:bg-orange-200 dark:text-orange-900'>
                          LOANABLE
                        </span>
                      )}
                    </div>
                    <div className='col-span-6 sm:col-span-2 pt-2'>
                      {propertyInformationData?.websitePublish && (
                        <span className='bg-orange-100 text-orange-800 text-xs font-semibold mt-2 px-2.5 py-1.5 rounded dark:bg-orange-200 dark:text-orange-900'>
                          Ad Publishable in Website
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animated>
        )}
        {activeTab === "buildandland" && (
          <Animated
            animationIn='bounceInRight'
            animationOut='bounceOutLeft'
            isVisible={activeTab === "buildandland"}>
            <div className='p-4 rounded-sm'>
              <div className='flex justify-items-start'>
                <div className='w-full'>
                  <div className='grid grid-cols-12 p-2 gap-2'>
                    {buildingList.includes(propertySubType.toLowerCase()) ? (
                      <>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='constructedArea'
                            className='block text-xs font-medium text-gray-700'>
                            Constructed Area
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.constructedArea
                              ? propertyInformationData?.constructedArea
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='carpetArea'
                            className='block text-xs font-medium text-gray-700'>
                            Carpet Area
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.carpetArea
                              ? propertyInformationData?.carpetArea
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='areaUnit'
                            className='block text-xs font-medium text-gray-700'>
                            Area Unit
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.areaUnitValue
                              ? propertyInformationData?.areaUnitValue +
                                " " +
                                propertyInformationData?.areaUnit
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='vastuCompliance'
                            className='block text-xs font-medium text-gray-700'>
                            Vastu Compliance
                          </label>
                          <div className='flex '>
                            <label className='ml-16 relative items-center cursor-pointer'>
                              <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                                {propertyInformationData?.vastuCompliance ? (
                                  <span className='font-semibold'>Yes</span>
                                ) : (
                                  "No"
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='facing'
                            className='block text-xs font-medium text-gray-700'>
                            Facing
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.facing
                              ? propertyInformationData?.facing
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='buildingFloors'
                            className='block text-xs font-medium text-gray-700'>
                            Building Floors
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.buildingFloors
                              ? propertyInformationData?.buildingFloors
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='buidlingAge'
                            className='block text-xs font-medium text-gray-700'>
                            Building Age
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.buidlingAge
                              ? propertyInformationData?.buildingAge + " Yrs"
                              : "--"}
                          </span>
                        </div>

                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='landSizeValue'
                            className='block text-xs font-medium text-gray-700'>
                            Land Size Value
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.landSizeValue
                              ? propertyInformationData?.landSizeValue
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='landExistingUse'
                            className='block text-xs font-medium text-gray-700'>
                            Land Existing Use
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.landExistingUse
                              ? propertyInformationData?.landExistingUse
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='dimensions'
                            className='block text-xs font-medium text-gray-700'>
                            Dimensions
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.dimensions
                              ? propertyInformationData?.dimensions
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-4'>
                          <label
                            htmlFor=''
                            className='block text-xs font-medium text-gray-700'>
                            Physical Measurement Taken
                          </label>
                          <div className='flex '>
                            <label className='ml-16 relative items-center cursor-pointer'>
                              <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                                {propertyInformationData?.physicalMeasurementEnabled ? (
                                  <span className='font-semibold'>Yes</span>
                                ) : (
                                  "No"
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='solidType'
                            className='block text-xs font-medium text-gray-700'>
                            Soil Type
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.solidType
                              ? propertyInformationData?.solidType
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor=''
                            className='block text-xs font-medium text-gray-700'>
                            Ground Water Availability
                          </label>
                          <div className='flex'>
                            <label className='ml-16 relative items-center cursor-pointer'>
                              <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                                {propertyInformationData?.groundWaterEnabled ? (
                                  <span className='font-semibold'>Yes</span>
                                ) : (
                                  "No"
                                )}
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='groundWaterType'
                            className='block text-xs font-medium text-gray-700'>
                            Ground Water Type
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.groundWaterType
                              ? propertyInformationData?.groundWaterType
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='groundWaterLevel'
                            className='block text-xs font-medium text-gray-700'>
                            Ground Water Level
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.groundWaterLevel
                              ? propertyInformationData?.groundWaterLevel
                              : "--"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='col-span-6 sm:col-span-4'>
                          <label
                            htmlFor='floorAllowedToConstruct'
                            className='block text-xs font-medium text-gray-700'>
                            Floors Allowed To Construct
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.floorAllowedToConstruct
                              ? propertyInformationData?.floorAllowedToConstruct
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='undividedShareValue'
                            className='block text-xs font-medium text-gray-700'>
                            Undivided Share Value
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.undividedShareValue
                              ? propertyInformationData?.undividedShareValue
                              : "--"}
                          </span>
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='areaUnit'
                            className='block text-xs font-medium text-gray-700'>
                            Area Unit
                          </label>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.areaUnitValue
                              ? propertyInformationData?.areaUnitValue +
                                " " +
                                propertyInformationData?.areaUnit
                              : "--"}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Animated>
        )}
        {activeTab === "hindrance" && (
          <Animated
            animationIn='bounceInRight'
            animationOut='bounceOutLeft'
            isVisible={activeTab === "hindrance"}>
            <div className='p-4 rounded-sm'>
              <div className='flex justify-items-start'>
                <div className='w-full'>
                  <div className='flex flex-wrap sm:space-x-6 space-x-0 px-3'>
                    <div className='px-2 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        EB HT
                      </label>
                      <div className='flex '>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.ebhtEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.ebhtEnabled && (
                      <div
                        className={`px-2 sm:col-span-2 ${
                          propertyInformationData?.ebhtEnabled
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='ebhtDistance'
                          className='block text-xs font-medium text-gray-700'>
                          EB HT Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.ebhtDistance
                            ? propertyInformationData?.ebhtDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='px-2 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        EB LT
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.ebltEnabled ? (
                          <span className='font-semibold'>Yes</span>
                        ) : (
                          "No"
                        )}
                      </span>
                    </div>
                    {propertyInformationData?.ebltEnabled && (
                      <div
                        className={`px-2 sm:col-span-2 ${
                          propertyInformationData?.ebltEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='ebltDistance'
                          className='block text-xs font-medium text-gray-700'>
                          EB LT Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.ebltDistance
                            ? propertyInformationData?.ebltDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='px-2 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Temple
                      </label>
                      <div className='flex'>
                        <label className='ml-2 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.templeEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.templeEnabled && (
                      <div
                        className={`px-2 sm:col-span-2 ${
                          propertyInformationData?.templeEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='templeDistance'
                          className='block text-xs font-medium text-gray-700'>
                          Temple Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.templeDistance
                            ? propertyInformationData?.templeDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='px-2 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Water
                      </label>
                      <div className='flex'>
                        <label className='ml-2 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.waterEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.waterEnabled && (
                      <div
                        className={`px-2 sm:col-span-2 ${
                          propertyInformationData?.waterEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='waterDistance'
                          className='block text-xs font-medium text-gray-700'>
                          Water Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.waterDistance
                            ? propertyInformationData?.waterDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='px-2 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Burial Ground
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.burialGroundEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.burialGroundEnabled && (
                      <div
                        className={`px-2 sm:col-span-3 ${
                          propertyInformationData?.burialGroundEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='burialGroundDistance'
                          className='block text-xs font-medium text-gray-700'>
                          Burial Ground Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.burialGroundDistance
                            ? propertyInformationData?.burialGroundDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='px-2 sm:col-span-2'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Railway Track
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.railwayTrackEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.railwayTrackEnabled && (
                      <div
                        className={`px-2 sm:col-span-3 ${
                          propertyInformationData?.railwayTrackEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='railwayTrackDistance'
                          className='block text-xs font-medium text-gray-700'>
                          Railway Track Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.railwayTrackDistance
                            ? propertyInformationData?.railwayTrackDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='hidden sm:col-span-1 sm:block'></div>
                    <div className='col-span-3 sm:col-span-2'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Poramboke
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.porambokeEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className='col-span-3 sm:col-span-1'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Quarry
                      </label>
                      <div className='flex '>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.quarryEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.quarryEnabled && (
                      <div
                        className={`px-2 sm:col-span-2 ${
                          propertyInformationData?.quarryEnabled
                            ? "block"
                            : "hidden"
                        } duration-300`}>
                        <label
                          htmlFor='quarryDistance'
                          className='block text-xs font-medium text-gray-700'>
                          Quarry Distance
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.quarryDistance
                            ? propertyInformationData?.quarryDistance
                            : "--"}
                        </span>
                      </div>
                    )}
                    <div className='col-span-12 sm:col-span-5'>
                      <label
                        htmlFor='advantages'
                        className='block text-xs font-medium text-gray-700'>
                        Advantages
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.advantages
                          ? propertyInformationData?.advantages
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-4'>
                      <label
                        htmlFor='opinion'
                        className='block text-xs font-medium text-gray-700'>
                        Opinion
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.opinion
                          ? propertyInformationData?.opinion
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12'>
                      <label
                        htmlFor='remarks'
                        className='block text-xs font-medium text-gray-700'>
                        Remarks
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.remarks
                          ? propertyInformationData?.remarks
                          : "--"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animated>
        )}
        {activeTab === "amenities" && (
          <Animated
            animationIn='bounceInRight'
            animationOut='bounceOutLeft'
            isVisible={activeTab === "amenities"}>
            <div className='p-4 rounded-sm'>
              <div className='flex justify-items-start'>
                <div className='w-full'>
                  <div className='flex flex-wrap sm:space-x-6 space-x-0 px-3'>
                    <div className='px-2 sm:col-span-2'>
                      <label
                        htmlFor='bedroomWithBalcony'
                        className='block text-xs font-medium text-gray-700'>
                        Bedroom with Balcony
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.bedroomWithBalcony
                          ? propertyInformationData?.bedroomWithBalcony
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='hallWithBalcony'
                        className='block text-xs font-medium text-gray-700'>
                        Hall with Balcony
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.hallWithBalcony}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='bedroomWithoutBalcony'
                        className='block text-xs font-medium text-gray-700'>
                        Bedroom without Balcony
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.bedroomWithoutBalcony}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-1'>
                      <label
                        htmlFor='kitchen'
                        className='block text-xs font-medium text-gray-700'>
                        Kitchen
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.kitchen}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='hallWIthBalcony'
                        className='block text-xs font-medium text-gray-700'>
                        Hall without Balcony
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.hallWithoutBalcony}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        In a Gated Society
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.gatedSociety ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className='col-span-4 sm:col-span-2'>
                      {propertyInformationData?.cornerProperty && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          CORNER PROPERTY
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1'>
                      {propertyInformationData?.petFriendly && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          PET FRIENDLY
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2'>
                      {propertyInformationData?.wheelchairFriendly && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          WHEELCHAIR FRIENDLY
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1'>
                      {propertyInformationData?.studyRoom && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          STUDY ROOM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1'>
                      {propertyInformationData?.storeRoom && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          STORE ROOM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1'>
                      {propertyInformationData?.poojaRoom && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          POOJA ROOM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1'>
                      {propertyInformationData?.servantRoom && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          SERVANT ROOM
                        </span>
                      )}
                    </div>
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor='boundaryWall'
                        className='block text-xs font-medium text-gray-700'>
                        Is Boundary Wall Made ?
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.boundaryWall !== ""
                          ? propertyInformationData?.boundaryWall
                          : "NA"}
                      </span>
                    </div>
                    <div className='col-span-3 sm:col-span-2'>
                      <label
                        htmlFor='bathrooms'
                        className='block text-xs font-medium text-gray-700'>
                        Bathrooms
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.bathrooms}
                      </span>
                    </div>
                    <div className='col-span-3 sm:col-span-2'>
                      <label
                        htmlFor='balconies'
                        className='block text-xs font-medium text-gray-700'>
                        Balconies
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.balconies}
                      </span>
                    </div>
                    <div className='col-span-4 sm:col-span-2'>
                      {propertyInformationData?.outdoorSportsEnabled && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          OUTDOOR SPORTS AVAILABLE
                        </span>
                      )}
                    </div>

                    {propertyInformationData?.outdoorSportsEnabled && (
                      <div
                        className={`col-span-6 sm:col-span-2 ${
                          propertyInformationData?.outdoorSportsEnabled
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='outdoorSports'
                          className='block text-xs font-medium text-gray-700'>
                          OutDoor Sports
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.outdoorSports}
                        </span>
                      </div>
                    )}
                    <div className='col-span-4 sm:col-span-2'>
                      {propertyInformationData?.indoorSportsEnabled && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          INDOOR SPORTS AVAILABLE
                        </span>
                      )}
                    </div>
                    {propertyInformationData?.indoorSportsEnabled && (
                      <div
                        className={`col-span-6 sm:col-span-2 ${
                          propertyInformationData?.indoorSportsEnabled
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='indoorSports'
                          className='block text-xs font-medium text-gray-700'>
                          InDoor Sports
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.indoorSports}
                        </span>
                      </div>
                    )}
                    <div className='col-span-6 sm:col-span-2'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Fittings
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.fittingsEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    {propertyInformationData?.fittingsEnabled && (
                      <div
                        className={`col-span-6 sm:col-span-2 ${
                          propertyInformationData?.fittingsEnabled
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='fittingsComment'
                          className='block text-xs font-medium text-gray-700'>
                          Fittings Comment
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.fittingsComment}
                        </span>
                      </div>
                    )}
                    <div className='col-span-12 sm:col-span-2'>
                      <label
                        htmlFor=''
                        className='block text-xs font-medium text-gray-700'>
                        Walls Paint
                      </label>
                      <div className='flex'>
                        <label className='ml-7 relative items-center cursor-pointer'>
                          <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                            {propertyInformationData?.wallsPaintEnabled ? (
                              <span className='font-semibold'>Yes</span>
                            ) : (
                              "No"
                            )}
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className='col-span-8 sm:col-span-3'>
                      <label
                        htmlFor='flooring'
                        className='block text-xs font-medium text-gray-700'>
                        Flooring
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.flooring}
                      </span>
                    </div>
                    {propertySubType
                      .toLowerCase()
                      .includes([
                        "guest house / banquet-halls",
                        "business and hotel",
                        "",
                      ]) && (
                      <div className='col-span-4 sm:col-span-2'>
                        <label
                          htmlFor='noofrooms'
                          className='block text-xs font-medium text-gray-700'>
                          No. of Rooms
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.noofrooms}
                        </span>
                      </div>
                    )}
                    {propertySubType
                      .toLowerCase()
                      .includes([
                        "guest house / banquet-halls",
                        "business and hotel",
                        "",
                      ]) && (
                      <div className='col-span-6 sm:col-span-2'>
                        <label
                          htmlFor='qualityRatings'
                          className='block text-xs font-medium text-gray-700'>
                          Quality Ratings
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.qualityRatings}
                        </span>
                      </div>
                    )}
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.furnishing && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          {propertyInformationData?.furnishing.toUpperCase()}
                        </span>
                      )}
                    </div>
                  </div>
                  {(propertyInformationData?.furnishing?.toLowerCase() ===
                    "furnished" ||
                    propertyInformationData?.furnishing?.toLowerCase() ===
                      "semi-furnished") && (
                    <div className='mt-3 grid grid-cols-12 gap-2 bg-yellow-50 rounded-md p-4'>
                      <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-base font-semibold leading-3 text-gray-dark '>
                          Furnishing
                        </h2>
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.wardrobe && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            WARDROBE-{propertyInformationData?.wardrobe}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.beds && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            BEDS-{propertyInformationData?.beds}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.geyser && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            GEYSER-{propertyInformationData?.geyser}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.fans && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            FANS-{propertyInformationData?.fans}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.light && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            LIGHT-{propertyInformationData?.light}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-2 pt-2'>
                        {propertyInformationData?.aircondition && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            AIRCONDITION-
                            {propertyInformationData?.aircondition}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.television && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            TELEVISION-{propertyInformationData?.television}
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.stove && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            STOVE
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.microwave && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            MICROWAVE
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.diningTable && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            DINING TABLE
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-2 pt-2'>
                        {propertyInformationData?.modularkitchen && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            MODULAR KITCHEN
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-2 pt-2'>
                        {propertyInformationData?.washingMachine && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            WASHING MACHINE
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.curtains && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            CURTAINS
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.fridge && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            FRIDGE
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.waterPurifier && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            WATER PURIFIER
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.chimney && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            CHIMNEY
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.sofaenabled && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            SOFA
                          </span>
                        )}
                      </div>
                      <div className='col-span-4 sm:col-span-1 pt-2'>
                        {propertyInformationData?.exhaustFan && (
                          <span className='bg-yellow-2 text-orange-800 text-xs font-semibold mt-2 px-2 py-1 rounded'>
                            EXHAUST FAN
                          </span>
                        )}
                      </div>

                      <div className='col-span-12 sm:col-span-4'>
                        <label
                          htmlFor='otherFurnishing'
                          className='block text-xs font-medium text-gray-700'>
                          Other Furnishing
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.otherFurnishing}
                        </span>
                      </div>
                    </div>
                  )}
                  <div className='flex flex-wrap sm:space-x-6 space-y-0 sm:sapce-y-4 space-x-2 px-3'>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.visitorParking && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          VISITOR PARKING
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.fireAlarm && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          FIRE ALARM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.securityPersonnel && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          SECURITY PERSONNEL
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.maintanenceStaff && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          MAINTANENCE STAFF
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.waterStorage && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          WATER STORAGE
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.centralAC && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          CENTRAL-AC
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.vaasthuCompliant && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          VAASTHU COMPLIANT
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.waterDisposal && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          WATER DISPOSAL
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.gym && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          GYM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.rainWaterHarvesting && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          RAIN WATER HARVESTING
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.swimmingPool && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          SWIMMING POOL
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.lifts && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          LIFTS
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.clubHouse && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          CLUBHOUSE
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.intercomFacility && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          INTERCOM FACILITY
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.serviceLift && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          SERVICE LIFT
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.atmenabled && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          ATM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.highSpeedInternet && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          HIGH-SPEED INTERNET
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.cafeteria && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          CAFETERIA
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.parkenabled && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          PARK
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.waterPurifier && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          WATER PURIFIER
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.barenabled && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          BAR
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.conferenceRoom && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          CONFERENCE ROOM
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.pipedGas && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          PIPED GAS
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-1 pt-2'>
                      {propertyInformationData?.privateGarden && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          PRIVATE GARDEN
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.shoppingCentre && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          SHOPPING CENTRE
                        </span>
                      )}
                    </div>
                    <div className='col-span-4 sm:col-span-2 pt-2'>
                      {propertyInformationData?.parkingAvailable && (
                        <span className='bg-yellow-dark text-white text-xs font-semibold mt-2 px-2 py-1 rounded'>
                          PARKING AVAILABLE
                        </span>
                      )}
                    </div>

                    {propertyInformationData?.parkingAvailable && (
                      <div
                        className={`col-span-6 sm:col-span-1 ${
                          propertyInformationData?.parkingAvailable
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='openParkingCnt'
                          className='block text-xs font-medium text-gray-700'>
                          Open Parking
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.openParkingCnt}
                        </span>
                      </div>
                    )}
                    {propertyInformationData?.parkingAvailable && (
                      <div
                        className={`col-span-6 sm:col-span-1 ${
                          propertyInformationData?.parkingAvailable
                            ? "opacity-100"
                            : "opacity-20"
                        } duration-300`}>
                        <label
                          htmlFor='closedParkingCnt'
                          className='block text-xs font-medium text-gray-700'>
                          Closed Parking
                        </label>
                        <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                          {propertyInformationData?.closedParkingCnt}
                        </span>
                      </div>
                    )}
                    <div className='col-span-6 sm:col-span-1 p-2'>
                      <label
                        htmlFor='powerBackup'
                        className='block text-xs font-medium text-gray-700'>
                        Power Backup
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.powerBackup
                          ? propertyInformationData?.powerBackup
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-6 sm:col-span-2 p-2'>
                      <label
                        htmlFor='waterSource'
                        className='block text-xs font-medium text-gray-700'>
                        Water Source
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.waterSource
                          ? propertyInformationData?.waterSource
                          : "--"}
                      </span>
                    </div>
                    <div className='col-span-12 sm:col-span-3 p-2'>
                      <label
                        htmlFor='overLooking'
                        className='block text-xs font-medium text-gray-700'>
                        Overlooking
                      </label>
                      <span className='mt-0 block w-full py-0 pb-3 font-semibold pl-5 text-sm text-justify '>
                        {propertyInformationData?.overLooking
                          ? propertyInformationData?.overLooking
                          : "--"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Animated>
        )}
      </div>
    </>
  );
};

export default PIFBody;
